import styles from './Locales.less';
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

class Locales extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale } = this.props;
    const isAU = locale === 'AU';
    const isNZ = locale === 'NZ';

    const listClasses = classnames({
      [styles.list]: true,
      [styles.list_isNZ]: isNZ
    });

    return (
      <nav role="navigation" className={styles.root}>

        <ScreenReaderOnly>
          <h1>Select your country</h1>
        </ScreenReaderOnly>

        <ul className={listClasses}>
          <li className={styles.listItem}>
            {
              isAU ?
                <span className={styles.locale_isActive}>AU</span> :
                <ExternalLink
                  analytics="header:au+homepage"
                  className={styles.localeLink}
                  href="https://www.seek.com.au"
                  title="SEEK Australia">
                  AU
                </ExternalLink>
            }
          </li>
          <li className={styles.listItem}>
            {
              isNZ ?
                <span className={styles.locale_isActive}>NZ</span> :
                <ExternalLink
                  analytics="header:nz+homepage"
                  className={styles.localeLink}
                  href="https://www.seek.co.nz"
                  title="SEEK New Zealand">
                  NZ
                </ExternalLink>
            }
          </li>
        </ul>

      </nav>
    );
  }

}

export default Locales;



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/Locales/Locales.js
 **/